import { AlertTriangle } from 'lucide-react';

interface QrAttentionBannerProps {
  count: number;
  onClick?: () => void;
}

/**
 * Sticky top banner shown when one or more accounts need a QR re-scan.
 *
 * CTO requirement #3: "如果出现 qr_required,请务必预留一个明显的 UI 提示位".
 * The amber treatment + warning icon makes the banner unmistakable; clicking
 * it scrolls/highlights the first `qr_required` row (handled by the parent
 * via `onClick`). Returns `null` when `count === 0` so the parent doesn't
 * have to gate the render.
 */
export function QrAttentionBanner({
  count,
  onClick,
}: QrAttentionBannerProps): React.JSX.Element | null {
  if (count <= 0) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className="neu-pressable sticky top-0 z-10 mx-4 mt-1 flex items-center gap-2 rounded-[13px] bg-orange-100/80 px-4 py-2.5 text-left text-xs font-bold text-orange-900 shadow-neu-raised hover:bg-orange-100 hover:shadow-neu-raised-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-400 dark:bg-orange-950/40 dark:text-orange-200 dark:hover:bg-orange-950/60"
    >
      <AlertTriangle className="size-4 shrink-0" aria-hidden="true" />
      <span>
        {count} account{count === 1 ? '' : 's'} need re-scan
      </span>
    </button>
  );
}
